export const __MessageTypes = {
    ERROR: "error",
    WARNING: "warning",
    SUCCESS: "success",
    INFO: "info"
}

export const __AccountType = {
    FBA: "FBA",
    AAD: "AAD",
}

export const __ProfileName = {
    sAdmin: "sAdmin",
    Admin: "Admin",
    User: "User",
    Auditor: "Observador",
}

export const __WhiteEmailDomainList = [
    '@global.komatsu',
    '@tripontis.tripontis'
]